// Author Liang Gang Qiang
// Date 2021-11-02 14:23:38

class MintalMesPrdIronOutput {
constructor({
        id = null,
        locationId = '',
        locationName = '',
        outputDate = '',
        materialId = '',
        output = '',
        remark = ''}
= {}) {
    this.id = id;
    this.locationId = locationId;
    this.locationName = locationName;
    this.outputDate = outputDate;
    this.materialId = materialId;
    this.output = output;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdIronOutput();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationId',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.grid.locationId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'outputDate',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.grid.outputDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialId',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.grid.materialId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialName',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.grid.materialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'output',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.grid.output',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    locationIdFilter : '',
    locationNameFilter : '',
    outputDateRteFilter : '',
    outputDateLteFilter : '',
    materialIdFilter : '',
    outputFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'locationNameFilter',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.filter.locationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId": "id"}'
                }
        },
        {
        key: 'outputDateRteFilter',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.filter.outputDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'outputDateLteFilter',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.filter.outputDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'materialIdFilter',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.filter.materialId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesMstMaterial'
            ,showLabelSelectOne: true
                    ,selectFilter:{typeFilter: '7'}
        }
        },
        {
        key: 'outputFilter',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.filter.output',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.entity.locationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId": "id"}'
                }
        },
        {
        key: 'outputDate',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.entity.outputDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'materialId',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.entity.materialId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesMstMaterial'
            ,showLabelSelectOne: true
                    ,selectFilter:{typeFilter: '7'}
        }
        },
        {
        key: 'output',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.entity.output',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdIronOutput.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdIronOutput, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
